import { events } from "./events";
import "jquery-touchswipe";
import "bootstrap-datepicker";

const MultiCarousel = () => {

    /**
     * Initialize the carousel with multiple visible items.
     *
     * @param {jQuery} $selector
     */
    const init = function ($selector = $(document)) {
        if (!($selector instanceof $)) {
            $selector = $($selector);
        }

        const carousels = $selector.find('.carousel.product-carousel').get();
        [...carousels].map((carousel) => {
            const carouselList = carousel.querySelectorAll('.carousel-multi-item'),
                buttons = carousel.getElementsByClassName('carousel-control'),
                carouselLength = carousel.querySelectorAll('.carousel-multi-item').length,
                containerWidth = getContainerWidth(window.document.body),
                slidesPerPage = getSlidesPerPage(containerWidth),
                className = 'col-' + (12 / slidesPerPage);

            [...carouselList].forEach(function (carouselItem) {
                let originalItem = carouselItem.children[0];
                if (!originalItem) {
                    return;
                }
                originalItem.classList.remove('col-12', 'col-6', 'col-4', 'col-3');

                // Remove the formerly created cloned items
                const clonedItems = carouselItem.querySelectorAll('[data-carousel-clone="1"]');
                clonedItems.forEach((clonedItem) => {
                    clonedItem.remove();
                });
                let next = carouselItem.nextElementSibling;
                for (let i = 1; i < slidesPerPage; i++) {
                    if (!next) {
                        // wrap carousel by using first child
                        next = carouselList[0];
                    }
                    let cloneChild = next.children[0]?.cloneNode(true);
                    if (cloneChild) {
                        cloneChild.dataset.carouselClone = '1';
                        carouselItem.appendChild(cloneChild);
                    }
                    next = next.nextElementSibling;
                }
                // @TODO how to handle slidesPerPage === carouselLength currently we still clone the not needed elements
                // @TODO cloned elements might have an event listener, how to replicate that?
            });

            // Hide carousel control with to few elements
            if ((carouselLength - slidesPerPage) <= 0) {
                buttons[0]?.classList.add('hidden');
                buttons[1]?.classList.add('hidden');
            } else {
                buttons[0]?.classList.remove('hidden');
                buttons[1]?.classList.remove('hidden');
            }
        });

        // add touchstart for econda in mobile
        $selector.find('.econda-opacity, .econda').off('touchstart');
        $selector.find('.econda-opacity, .econda').on('touchstart', function (event) {
            event.preventDefault();
            $(this).off('hover');
            $(this).addClass('touch-effect');
        });
        $selector.find('.econda-content').off('touchstart');
        $selector.find('.econda-content').on('touchstart', function (e) {
            e.stopPropagation();
            $(this).on('click');
        });

        /**
         * sales teasers in a product carousel
         */
        $selector.find('.product-carousel').each((index, productCarousel) => {
            const $productCarousel = $(productCarousel);
            $productCarousel.off('click');
            $productCarousel.on('click', e => {
                let $link
                if (e.target?.attributes?.href?.value === '#' || e.target?.parentElement?.attributes?.href?.value === '#') {
                    return;
                }
                const $article = $(e.target).closest('article[data-setu-href]');

                if ($article.length === 1) {
                    $link = $article.find('a[href]');

                    if ($link.length > 0) {
                        $link = $link.first();
                        e.preventDefault();
                        events.fireDataEvent('salesTeaser.click', [$article, e]);
                        window.open($link.attr('href'), $link.attr('target') === '_blank' ? '_blank' : '_self');
                    }
                }
            });
        });
    };

    const getContainerWidth = el => {
        let width;
        if (($(el).parent().parent().closest('.tab-pane')).length > 0) {
            const tabEl = $(el).parent().parent().closest('.tab-pane');
            const clone = tabEl[0].cloneNode(true);
            if (tabEl && tabEl[0].getElementsByClassName('active').length === 0) {
                tabEl.attr('display', 'block');
            }
            clone.style.visibility = 'hidden';
            document.body.appendChild(clone);
            width = clone.clientWidth;
            clone.remove();
            if (tabEl && tabEl[0].getElementsByClassName('active').length === 0) {
                tabEl.attr('display', 'none');

            }
        } else {
            width = el.clientWidth;
        }

        return width;
    };

    const getSlidesPerPage = containerWidth => {
        let slidesPerPage;

        if (containerWidth < 576) {
            slidesPerPage = 1; // 'col-12'
        } else {
            if (containerWidth < 768) {
                slidesPerPage = 2; // 'col-6'
            } else {
                if (containerWidth < 960) {
                    slidesPerPage = 3; // 'col-4'
                } else {
                    slidesPerPage = 4; // 'col-3'
                }
            }
        }
        return slidesPerPage;
    };

    return {
        init,
    }
}
export const multiCarousel = MultiCarousel();
